import { withLazy } from '@pay24/ui'
import { lazy } from 'react'

export const App = withLazy(lazy(() => import('./App')))
